import { useState, useEffect, useContext } from 'react';
import { FetchContext } from '@src/scenario-editor/providers/fetch.context';
export type { FetchTaskManagementsPayload } from '@src/scenario-editor/providers/fetch.context';

interface TaskManagement {
  id: string;
  title: string;
  type: string;
  description: string;
}

export const useFetchTaskManagements = () => {
  const [taskManagements, setTaskManagements] = useState<TaskManagement[]>([]);
  const [isLoading, setIsLoading] = useState<null | boolean>(null);
  const fetchContext = useContext(FetchContext);

  if (!fetchContext) {
    throw new Error('FetchContext is not provided');
  }

  useEffect(() => {
    const fetchTaskManagements = async () => {
      try {
        setIsLoading(true);
        const taskManagements = await fetchContext.fetchTaskManagements();

        setTaskManagements(
          taskManagements.data
        );
        setIsLoading(false);
      } catch (e) {
        console.error(e);
      }
    };
    fetchTaskManagements().catch(console.error);
  }, [fetchContext]);

  return [taskManagements, isLoading];
};
